module.exports = __webpack_public_path__ + "static/media/proordem-online.83868fac.svg";